import { useState } from 'react';

import { useIntl } from 'react-intl';

import { IDeliveryAddressLocation } from 'components/address-modal/save-delivery-address/types';
import { IDeliveryAddress } from 'generated/rbi-graphql';
import { useDialogModal } from 'hooks/use-dialog-modal';
import { useRemoveDeliveryAddress } from 'hooks/use-remove-delivery-address';
import { StoreLocatorSteps } from 'pages/store-locator/types';
import { toast } from 'utils/toast';

interface UseDeleteSavedAddressParams {
  setCurrentStep: (step: StoreLocatorSteps) => void;
  setDeliveryAddress: (deliveryAddress: IDeliveryAddressLocation | undefined) => void;
}

export const useDeleteSavedAddress = ({
  setCurrentStep,
  setDeliveryAddress,
}: UseDeleteSavedAddressParams) => {
  const { formatMessage } = useIntl();
  const { removeDeliveryAddress } = useRemoveDeliveryAddress();

  const [selectedAddress, setSelectedAddress] = useState<IDeliveryAddress>();

  const removeSavedAddressModalBody = selectedAddress
    ? formatMessage({ id: 'removeSavedAddressBodyAlt' })
    : '';

  const handleModalConfirm = (address: IDeliveryAddress) => {
    const handleDeliveryAddressRemove = async () => {
      const result = await removeDeliveryAddress({
        variables: {
          input: {
            alias: address.alias,
            addressLine1: address.addressLine1,
            city: address.city,
            phoneNumber: address.phoneNumber,
          },
        },
      });
      if (!result.errors) {
        toast.success(formatMessage({ id: 'removeSavedAddressSuccess' }));
        setDeliveryAddress(undefined);
        setCurrentStep(StoreLocatorSteps.ADDRESS_SELECTOR);
      }
    };

    handleDeliveryAddressRemove();
  };

  const [RemoveSavedAddressModal, openRemoveSavedAddressModal] = useDialogModal({
    onConfirm: (address: IDeliveryAddress) => {
      handleModalConfirm(address);
    },
    onOpen: (address: IDeliveryAddress) => {
      setSelectedAddress(address);
    },
    showCancel: true,
    modalAppearanceEventMessage: 'Remove Saved Address',
  });

  return {
    RemoveSavedAddressModal,
    removeSavedAddressModalBody,
    openRemoveSavedAddressModal,
  };
};
